import React from 'react';
import { Link } from 'react-router-dom';
import { CardHeader, CardTitle } from 'reactstrap';
import SFB_Logo from '../images/SFB_Logo.png';
import MainNav from './MainNav';

function MainCardHeader() {    
  return (
    <CardHeader className="topbar-shell bg-darkest rounded-top border-0 border-bottom border-primary-orange-subtle d-flex justify-content-center align-items-center gap-4 px-3 px-lg-4 py-3 shadow-sm">
            <div className="d-flex align-items-center gap-3 flex-basis-0 flex-grow-1">
                <Link to="/" className="brand-slot">
                    <img fetchpriority="high" src={SFB_Logo} alt="Spitface Battles Logo" width="72" height="72" loading="eager" decoding="async" className="img-fluid rounded-circle shadow-xs" />
                </Link>

                <Link to="/" className="text-decoration-none">
                    <CardTitle className="site-title d-flex flex-column justify-content-start align-items-start lh-tight text-uppercase mb-0 site-title anton-regular">
                        <span className="text-primary-orange">Spitface</span>
                        <span className="fs-6 text-white">Battles</span>
                    </CardTitle>
                </Link>
            </div>
                
                
            <MainNav />
    </CardHeader>
  )
}

export default MainCardHeader;
